export const productName = 'SOLAR ENERGY & PHOTOVOLTAIC SYSTEMS — PROFESSIONAL EDITION';
export const productShortName = 'Solar Energy & Photovoltaic Systems — Professional Edition';
export const productBrand = 'Solar Energy & Photovoltaic Systems';
export const productEdition = 'Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/iru4DmJVk11QBTSWtVAk7e/MOCKUP_(2).png';

export const checkoutUrl = 'https://solar-energy-photovoltaic-systems.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more uncertainty about system sizing and design',
  'No more troubleshooting without systematic thinking',
  'No more unconfident technical conversations',
  'No more limited career prospects',
];
